export const unknownSenderOrRecipient = "iRd";
export default {unknownSenderOrRecipient};